module.exports = __webpack_public_path__ + "static/media/logo.6ba5f5ab.png";